export enum TruckOperationStatus {
  Operational = 'OPERATIONAL',
  NotOperational = 'NOT_OPERATIONAL',
  StandBy = 'STAND_BY',
  UnderMaintenance = 'UNDER_MAINTENANCE',
  OperationDistribution = 'OPERATION_DISTRIBUTION'
}
